import React from 'react';
import { ProfitMaximizerUpsell } from '../components/ProfitMaximizerUpsell';
export function Modulo4Page() {
  return <div className="min-h-screen bg-[#0a0a0a] text-[#e0e0e0] font-body" data-id="element-1480">
      {/* TOP NAV */}
      <nav className="sticky top-0 z-[100] flex h-[56px] items-center justify-between border-b border-[#1a1a1a] bg-black px-4 md:px-10" data-id="element-1481">
        <div className="font-heading text-[13px] font-black tracking-[3px] text-white uppercase" data-id="element-1482">
          AI <span className="text-[#F5C842]" data-id="element-1483">WEB CLOSER</span>
        </div>
        <div className="flex gap-1 overflow-x-auto" data-id="element-1484">
          <a href="/modulo-0" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1485">
            Módulo 0
          </a>
          <a href="/modulo-1" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1486">
            Módulo 1
          </a>
          <a href="/modulo-2" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1487">
            Módulo 2
          </a>
          <a href="/modulo-3" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1488">
            Módulo 3
          </a>
          <a href="/modulo-4" className="rounded bg-[#F5C842] px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-black transition-all" data-id="element-1489">
            Módulo 4
          </a>
          <a href="/calculadora" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#F5C842] transition-all hover:bg-[#1a1a1a] border border-[#F5C842]/30" data-id="element-1490">
            Calculadora
          </a>
        </div>
      </nav>

      {/* HERO */}
      <div className="border-b-[3px] border-[#F5C842] bg-gradient-to-br from-black to-[#0d0d0d] px-6 py-10 md:px-20 md:py-[60px] md:pb-[50px]" data-id="element-1491">
        <div className="mb-5 flex items-center gap-2.5" data-id="element-1492">
          <div className="rounded-sm bg-[#F5C842] px-3.5 py-1 font-heading text-[9px] font-black tracking-[3px] text-black uppercase" data-id="element-1493">
            Módulo 4 de 4 — Final
          </div>
          <div className="text-[11px] tracking-[2px] text-[#444] uppercase" data-id="element-1494">
            ⏱ 15 minutos · El Guion de Cierre Completo
          </div>
        </div>
        <div className="mb-4 font-heading text-4xl md:text-[48px] font-black leading-[1.05] text-white" data-id="element-1495">
          El Cierre
          <br data-id="element-1496" />
          <span className="text-[#F5C842]" data-id="element-1497">Sin Presión</span>
        </div>
        <div className="mb-8 max-w-[600px] text-[15px] leading-[1.7] text-[#888]" data-id="element-1498">
          El guion exacto para convertir una conversación casual en una venta de
          $350. No es una venta — es una conversación. Y tienes algo que ellos
          quieren.
        </div>
        <div className="flex flex-col md:flex-row gap-4 md:gap-6" data-id="element-1499">
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-1500">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1501"></div>
            Guion de apertura + seguimiento
          </div>
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-1502">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1503"></div>
            Las 5 objeciones y cómo responderlas
          </div>
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-1504">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1505"></div>
            Estrategia de precios y plan de pagos
          </div>
        </div>
      </div>

      {/* MAIN */}
      <div className="mx-auto max-w-[1100px] px-4 py-10 md:px-10 md:py-[50px]" data-id="element-1506">
        {/* MINDSET BANNER */}
        <div className="mb-8 rounded-r-lg border border-[#2a2a2a] border-l-[4px] border-l-[#F5C842] bg-gradient-to-br from-[#0d0d0d] to-[#111] px-7 py-6" data-id="element-1507">
          <div className="mb-2 font-heading text-[16px] font-black text-[#F5C842]" data-id="element-1508">
            &#x1F4A1; El Cambio de Mentalidad que lo Cambia Todo
          </div>
          <div className="text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1509">
            Sé que para muchos esta es la parte más intimidante. Llamar a un
            extraño y ofrecerle algo. Pero cuando termines este módulo, vas a
            ver que{' '}
            <strong className="text-white" data-id="element-1510">
              no es una venta. Es una conversación.
            </strong>{' '}
            Y tienes algo que ellos quieren — su negocio representado de forma
            profesional en internet.
          </div>
        </div>

        {/* SCRIPT CARDS */}
        <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1511">
          <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1512"></span>
          El Guion de Cierre — Copiar y Pegar
        </div>

        {/* PASO 1 */}
        <div className="mb-5 overflow-hidden rounded-[10px] border border-[#2a2a2a] bg-black" data-id="element-1513">
          <div className="flex items-center gap-2.5 border-b border-[#1e1e1e] bg-[#111] px-[22px] py-3.5" data-id="element-1514">
            <span className="text-[18px]" data-id="element-1515">📱</span>
            <span className="font-heading text-[13px] font-black text-white" data-id="element-1516">
              PASO 1 — Apertura (WhatsApp o llamada)
            </span>
            <span className="ml-auto text-[10px] text-[#555]" data-id="element-1517">
              ⏱ Primer contacto
            </span>
          </div>
          <div className="whitespace-pre-wrap px-[22px] py-[22px] text-[13px] italic leading-[1.85] text-[#ccc]" data-id="element-1518">
            "Hola, ¿hablo con{' '}
            <span className="italic text-[#666]" data-id="element-1519">[Nombre del dueño]</span>? Mi
            nombre es <span className="italic text-[#666]" data-id="element-1520">[Tu nombre]</span>.
            Vi su negocio{' '}
            <span className="italic text-[#666]" data-id="element-1521">[Nombre del negocio]</span> en
            Google Maps y noté que no tienen sitio web. Tomé 10 minutos y
            preparé una demo de cómo podría verse. ¿Le puedo enviar el link para
            que lo vea?"
            <br data-id="element-1522" />
            <br data-id="element-1523" />
            <span className="not-italic font-bold text-white" data-id="element-1524">
              — Eso es todo. No vendas nada todavía. Solo pide permiso para
              enviar el link.
            </span>
            <br data-id="element-1525" />
            <span className="not-italic font-bold text-white" data-id="element-1526">
              — La mayoría dirá que sí porque es gratis y no les pides nada.
            </span>
          </div>
        </div>

        {/* PASO 2 */}
        <div className="mb-5 overflow-hidden rounded-[10px] border border-[#2a2a2a] bg-black" data-id="element-1527">
          <div className="flex items-center gap-2.5 border-b border-[#1e1e1e] bg-[#111] px-[22px] py-3.5" data-id="element-1528">
            <span className="text-[18px]" data-id="element-1529">⏳</span>
            <span className="font-heading text-[13px] font-black text-white" data-id="element-1530">
              PASO 2 — Envía la demo y espera
            </span>
            <span className="ml-auto text-[10px] text-[#555]" data-id="element-1531">
              ⏱ Inmediatamente después
            </span>
          </div>
          <div className="whitespace-pre-wrap px-[22px] py-[22px] text-[13px] italic leading-[1.85] text-[#ccc]" data-id="element-1532">
            Cuando digan que sí,{' '}
            <span className="not-italic font-bold text-[#F5C842]" data-id="element-1533">
              envía el link de la demo
            </span>{' '}
            que construiste en el Módulo 3.
            <br data-id="element-1534" />
            <br data-id="element-1535" />
            <span className="not-italic font-bold text-white" data-id="element-1536">
              Espera exactamente 10 minutos.
            </span>
            <br data-id="element-1537" />
            <br data-id="element-1538" />
            No escribas antes. No preguntes si la vieron. Espera los 10 minutos
            y luego envía el seguimiento.
          </div>
        </div>

        {/* PASO 3 */}
        <div className="mb-8 overflow-hidden rounded-[10px] border border-[#2a2a2a] bg-black" data-id="element-1539">
          <div className="flex items-center gap-2.5 border-b border-[#1e1e1e] bg-[#111] px-[22px] py-3.5" data-id="element-1540">
            <span className="text-[18px]" data-id="element-1541">💰</span>
            <span className="font-heading text-[13px] font-black text-white" data-id="element-1542">
              PASO 3 — Seguimiento y cierre
            </span>
            <span className="ml-auto text-[10px] text-[#555]" data-id="element-1543">
              ⏱ 10 minutos después de enviar la demo
            </span>
          </div>
          <div className="whitespace-pre-wrap px-[22px] py-[22px] text-[13px] italic leading-[1.85] text-[#ccc]" data-id="element-1544">
            "¿Tuvo oportunidad de verlo? ¿Qué le pareció? Puedo tenerlo listo y
            publicado en{' '}
            <span className="not-italic font-bold text-[#F5C842]" data-id="element-1545">
              48 horas por $350
            </span>
            . Incluye el dominio y el primer mes de hosting."
            <br data-id="element-1546" />
            <br data-id="element-1547" />
            <span className="not-italic font-bold text-white" data-id="element-1548">
              Si dicen que sí → cobras.
            </span>
            <br data-id="element-1549" />
            <span className="not-italic font-bold text-white" data-id="element-1550">
              Si dicen que es caro → ofrece plan de pagos: $175 ahora, $175 en
              30 días.
            </span>
            <br data-id="element-1551" />
            <span className="not-italic font-bold text-white" data-id="element-1552">
              Si siguen sin cerrar → pasa al siguiente prospecto. No negocies
              demasiado. Tu tiempo vale.
            </span>
          </div>
        </div>

        {/* PRICING */}
        <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1553">
          <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1554"></span>
          Estructura de Precios
        </div>
        <div className="mb-8 grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-1555">
          <div className="rounded-lg border border-[#F5C842] bg-[#0d0d0d] p-5 text-center" data-id="element-1556">
            <div className="mb-2 text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1557">
              Precio Estándar
            </div>
            <div className="mb-1.5 font-heading text-[32px] font-black text-[#F5C842]" data-id="element-1558">
              $350
            </div>
            <div className="text-[11px] leading-[1.5] text-[#666]" data-id="element-1559">
              Sitio web completo + dominio + primer mes de hosting. Pago único
              al cerrar.
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] p-5 text-center" data-id="element-1560">
            <div className="mb-2 text-[9px] font-bold tracking-[2px] text-[#555] uppercase" data-id="element-1561">
              Plan de Pagos
            </div>
            <div className="mb-1.5 font-heading text-[32px] font-black text-white" data-id="element-1562">
              2x$175
            </div>
            <div className="text-[11px] leading-[1.5] text-[#666]" data-id="element-1563">
              $175 al cerrar + $175 a los 30 días. Para clientes que dicen "es
              caro".
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] p-5 text-center" data-id="element-1564">
            <div className="mb-2 text-[9px] font-bold tracking-[2px] text-[#555] uppercase" data-id="element-1565">
              Mantenimiento Mensual
            </div>
            <div className="mb-1.5 font-heading text-[32px] font-black text-white" data-id="element-1566">
              $99/mes
            </div>
            <div className="text-[11px] leading-[1.5] text-[#666]" data-id="element-1567">
              Hosting, actualizaciones y soporte. Ofrécelo después de entregar
              el sitio.
            </div>
          </div>
        </div>

        {/* OBJECTIONS */}
        <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1568">
          <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1569"></span>
          Las 5 Objeciones Más Comunes y Cómo Responderlas
        </div>
        <div className="mb-8 grid grid-cols-1 md:grid-cols-2 gap-3.5" data-id="element-1570">
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-1571">
            <div className="flex items-center gap-2 border-b border-[#2a1a1a] bg-[#1a0a0a] px-4 py-2.5 text-[12px] font-bold text-[#ff6b6b]" data-id="element-1572">
              ❌ "Es muy caro."
            </div>
            <div className="px-4 py-3.5 text-[12px] leading-[1.65] text-[#bbb]" data-id="element-1573">
              <span className="font-bold text-[#4caf50]" data-id="element-1574">✅ Tu respuesta:</span>{' '}
              "Entiendo. ¿Cuánto le cuesta perder un cliente porque no lo
              encontraron en Google?"
            </div>
          </div>
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-1575">
            <div className="flex items-center gap-2 border-b border-[#2a1a1a] bg-[#1a0a0a] px-4 py-2.5 text-[12px] font-bold text-[#ff6b6b]" data-id="element-1576">
              ❌ "Ya tengo uno."
            </div>
            <div className="px-4 py-3.5 text-[12px] leading-[1.65] text-[#bbb]" data-id="element-1577">
              <span className="font-bold text-[#4caf50]" data-id="element-1578">✅ Tu respuesta:</span>{' '}
              "¿Puedo verlo? [Pausa] Entiendo. ¿Le gustaría uno que realmente
              traiga clientes?"
            </div>
          </div>
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-1579">
            <div className="flex items-center gap-2 border-b border-[#2a1a1a] bg-[#1a0a0a] px-4 py-2.5 text-[12px] font-bold text-[#ff6b6b]" data-id="element-1580">
              ❌ "Déjame pensarlo."
            </div>
            <div className="px-4 py-3.5 text-[12px] leading-[1.65] text-[#bbb]" data-id="element-1581">
              <span className="font-bold text-[#4caf50]" data-id="element-1582">✅ Tu respuesta:</span>{' '}
              "Por supuesto. ¿Cuándo podría hablar con usted de nuevo? ¿Mañana a
              las 10?"
            </div>
          </div>
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-1583">
            <div className="flex items-center gap-2 border-b border-[#2a1a1a] bg-[#1a0a0a] px-4 py-2.5 text-[12px] font-bold text-[#ff6b6b]" data-id="element-1584">
              ❌ "No tengo tiempo."
            </div>
            <div className="px-4 py-3.5 text-[12px] leading-[1.65] text-[#bbb]" data-id="element-1585">
              <span className="font-bold text-[#4caf50]" data-id="element-1586">✅ Tu respuesta:</span>{' '}
              "No se preocupe, yo me encargo de todo. Usted solo me aprueba el
              diseño."
            </div>
          </div>
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111] md:col-span-2" data-id="element-1587">
            <div className="flex items-center gap-2 border-b border-[#2a1a1a] bg-[#1a0a0a] px-4 py-2.5 text-[12px] font-bold text-[#ff6b6b]" data-id="element-1588">
              ❌ "No sé si lo necesito."
            </div>
            <div className="px-4 py-3.5 text-[12px] leading-[1.65] text-[#bbb]" data-id="element-1589">
              <span className="font-bold text-[#4caf50]" data-id="element-1590">✅ Tu respuesta:</span>{' '}
              "Entiendo. ¿Sabe cuántas personas buscan{' '}
              <span className="text-[#F5C842]" data-id="element-1591">[tipo de negocio]</span> en
              Google en su ciudad cada mes? Sin sitio web, ninguna de ellas lo
              encuentra a usted."
            </div>
          </div>
        </div>

        {/* FULL SCRIPT */}
        <div className="mb-8" data-id="element-1592">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1593">
            <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1594"></span>
            Guion Completo del Módulo
          </div>

          <div className="mb-4" data-id="element-1595">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1596">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-1597"></span>⏱
              0:00 – 0:30 · Introducción
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-1598">
              "Módulo 4. El cierre. Sé que para muchos esta es la parte más
              intimidante. Llamar a un extraño y ofrecerle algo. Pero te prometo
              que cuando termines este módulo, vas a ver que no es una venta. Es
              una conversación. Y tienes algo que ellos quieren."
            </div>
          </div>

          <div className="mb-4" data-id="element-1599">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1600">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-1601"></span>⏱
              0:30 – 10:00 · El Guion de Cierre
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-1602">
              "Voy a darte el guion exacto. Puedes leerlo las primeras veces si
              necesitas. Con el tiempo, será natural."
              <br data-id="element-1603" />
              <br data-id="element-1604" />
              <span className="not-italic font-bold text-[#F5C842]" data-id="element-1605">
                APERTURA (WhatsApp o llamada):
              </span>
              <br data-id="element-1606" />
              "'Hola, ¿hablo con{' '}
              <span className="italic text-[#666]" data-id="element-1607">[Nombre del dueño]</span>? Mi
              nombre es <span className="italic text-[#666]" data-id="element-1608">[Tu nombre]</span>.
              Vi su negocio{' '}
              <span className="italic text-[#666]" data-id="element-1609">[Nombre del negocio]</span>{' '}
              en Google Maps y noté que no tienen sitio web. Tomé 10 minutos y
              preparé una demo de cómo podría verse. ¿Le puedo enviar el link
              para que lo vea?'"
              <br data-id="element-1610" />
              <br data-id="element-1611" />
              "Eso es todo. No vendas nada todavía. Solo pide permiso para
              enviar el link."
              <br data-id="element-1612" />
              <br data-id="element-1613" />
              "Cuando digan que sí (y la mayoría dirá que sí porque es gratis y
              no les pides nada), envía el link de la demo y espera 10 minutos.
              Luego escribe:"
              <br data-id="element-1614" />
              <br data-id="element-1615" />
              <span className="not-italic font-bold text-[#F5C842]" data-id="element-1616">
                SEGUIMIENTO:
              </span>
              <br data-id="element-1617" />
              "'¿Tuvo oportunidad de verlo? ¿Qué le pareció? Puedo tenerlo listo
              y publicado en 48 horas por $350. Incluye el dominio y el primer
              mes de hosting.'"
              <br data-id="element-1618" />
              <br data-id="element-1619" />
              "Si dicen que sí, cobras. Si dicen que es caro, tienes dos
              opciones: ofrecer un plan de pagos ($175 ahora, $175 en 30 días) o
              simplemente pasar al siguiente prospecto. No negocies demasiado.
              Tu tiempo vale."
            </div>
          </div>

          <div className="mb-4" data-id="element-1620">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1621">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-1622"></span>⏱
              10:00 – 13:00 · Las 5 Objeciones
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-1623">
              "Las 5 objeciones más comunes y cómo responderlas:"
              <br data-id="element-1624" />
              <br data-id="element-1625" />
              "1. 'Es muy caro.' → 'Entiendo. ¿Cuánto le cuesta perder un
              cliente porque no lo encontraron en Google?'"
              <br data-id="element-1626" />
              "2. 'Ya tengo uno.' → '¿Puedo verlo? [Pausa] Entiendo. ¿Le
              gustaría uno que realmente traiga clientes?'"
              <br data-id="element-1627" />
              "3. 'Déjame pensarlo.' → 'Por supuesto. ¿Cuándo podría hablar con
              usted de nuevo? ¿Mañana a las 10?'"
              <br data-id="element-1628" />
              "4. 'No tengo tiempo.' → 'No se preocupe, yo me encargo de todo.
              Usted solo me aprueba el diseño.'"
              <br data-id="element-1629" />
              "5. 'No sé si lo necesito.' → 'Entiendo. ¿Sabe cuántas personas
              buscan [tipo de negocio] en Google en su ciudad cada mes? Sin
              sitio web, ninguna de ellas lo encuentra a usted.'"
            </div>
          </div>

          <div className="mb-4" data-id="element-1630">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1631">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-1632"></span>⏱
              13:00 – 15:00 · Cierre Final del Curso
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-1633">
              "Eso es todo. Tienes el sistema completo. Ahora ve y contacta tus
              5 prospectos hoy. No mañana. Hoy. El dinero está ahí afuera
              esperándote. El único paso que falta eres tú."
            </div>
          </div>
        </div>

        {/* TASK */}
        <div className="mb-8 rounded-r-lg border border-[#1a3a1a] border-l-[4px] border-l-[#4caf50] bg-[#0a150a] px-[26px] py-[22px]" data-id="element-1634">
          <div className="mb-2.5 font-heading text-[9px] font-bold tracking-[2px] text-[#4caf50] uppercase" data-id="element-1635">
            ✅ Tu Tarea Final — Módulo 4
          </div>
          <div className="text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1636">
            Contacta a tus{' '}
            <strong className="text-white" data-id="element-1637">5 prospectos hoy</strong>. No mañana.
            Hoy. Tu objetivo es cerrar al menos 1 venta esta semana.
            <div className="mt-3 flex flex-col gap-2" data-id="element-1638">
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1639">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1640">
                  1
                </div>
                Envía el mensaje de apertura al Prospecto #1 (WhatsApp o
                llamada)
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1641">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1642">
                  2
                </div>
                Cuando diga que sí, envía el link de su demo
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1643">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1644">
                  3
                </div>
                Espera 10 minutos y envía el seguimiento con el precio de $350
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1645">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1646">
                  4
                </div>
                Repite con los 5 prospectos de tu lista
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1647">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1648">
                  5
                </div>
                <strong className="text-white" data-id="element-1649">
                  Objetivo: cerrar al menos 1 venta esta semana
                </strong>
              </div>
            </div>
          </div>
        </div>

        {/* CLOSING BANNER */}
        <div className="mb-8 rounded-lg border border-[#2a2a2a] border-t-[3px] border-t-[#F5C842] bg-black px-10 py-10 text-center" data-id="element-1650">
          <div className="mb-3 font-heading text-[28px] font-black leading-tight text-white" data-id="element-1651">
            Ahora Ve y<br data-id="element-1652" />
            <span className="text-[#F5C842]" data-id="element-1653">Cierra Tu Primer Cliente</span>
          </div>
          <div className="mx-auto max-w-[500px] text-[14px] leading-[1.7] text-[#777]" data-id="element-1654">
            Tienes el sistema completo. Los cerebros de IA. El guion. Las demos.
            El único paso que falta eres tú. El dinero está ahí afuera
            esperándote.
          </div>
        </div>

        {/* PROFIT MAXIMIZER UPSELL */}
        <ProfitMaximizerUpsell data-id="element-1655" />
      </div>

      {/* FOOTER NAV */}
      <div className="mt-5 flex items-center justify-between border-t border-[#1a1a1a] bg-black px-4 py-6 md:px-10" data-id="element-1656">
        <a href="/modulo-3" className="flex items-center gap-1.5 text-[12px] font-bold text-[#555] transition-colors hover:text-white" data-id="element-1657">
          ← Módulo 3
        </a>
        <div className="font-heading text-[11px] font-black tracking-[3px] text-[#333] uppercase" data-id="element-1658">
          AI <span className="text-[#F5C842]" data-id="element-1659">WEB CLOSER</span>
        </div>
        <div className="rounded bg-[#4caf50] px-7 py-3 font-heading text-[12px] font-black tracking-[1px] text-black uppercase" data-id="element-1660">
          ✓ Curso Completado
        </div>
      </div>
    </div>;
}